import React from 'react';
import './ErrorBoundary.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <div className="error-boundary-card">
            <div className="error-boundary-icon">Oups</div>
            <h2 className="error-boundary-title">
              Une erreur est survenue
            </h2>
            <p className="error-boundary-message">
              L'application a rencontré un problème inattendu. Essayez de recharger la page.
            </p>
            <div className="error-boundary-actions">
              <button
                onClick={this.handleRetry}
                className="error-boundary-btn error-boundary-btn--primary"
              >
                Réessayer
              </button>
              <button
                onClick={() => window.location.href = '/dashboard'}
                className="error-boundary-btn error-boundary-btn--secondary"
              >
                Accueil
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
